import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { environment } from 'projects/max/dfup-storeupweb-fe/src/environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  isMobile = false;
  hamburgerMenu = false;

  constructor(public breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([`(max-width: ${environment.mobileMaxWidth}px)`])
      .subscribe((state: BreakpointState) => {
        this.isMobile = state.matches;
      });

  }
}
